/*
These all are custom Hooks 
*/

// import React from 'react'
// import {useSelector} from 'react-redux'
import { useQueryWithStore, useQuery, useRefresh } from "react-admin"
import { useSelector, useDispatch } from "react-redux"
import { selectTimeSlot, confirmAppointment, selectAttendees, addRequestMessage, getAvailableSlots, selectIsGroup } from "./actions";
import { useHistory } from 'react-router-dom';
// import Parse from "./../../Utils/index"
// import moment from 'moment'
import { useEffect } from "react";
// const locationSelector = state=>state.router.location

export const useMentorProfileData = (mentorId) => {
    const selectedMentor = useSelector(state => state.appointment ? state.appointment.selectedMentor : null)
    const mentorData = useQueryWithStore({
        type: 'getOne',
        resource: 'User',
        payload: { id: mentorId ? mentorId : selectedMentor }
    });

    return { mentorData }
}

export const useMentorCertificationData = (mentorId) => {
    const { mentorData } = useMentorProfileData(mentorId)
    const certificationData = useQuery({
        type: 'getMany',
        resource: 'Certification',
        payload: { ids: mentorData.loaded && mentorData.data ? mentorData.data.Certification : [] }
    });
    return { certificationData }
}

export const useAppointment = (init) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const refresh = useRefresh()
    return {
        selectTimeSlot: (payload) => {
            dispatch(selectTimeSlot(payload))
            history.replace("/schedule3")
            refresh()
        },
        selectAttendees: (payload) => {
            dispatch(selectAttendees(payload))
            history.replace("/schedule4")
            refresh()
        },
        addRequestMessage: (payload) => {
            dispatch(addRequestMessage(payload))
            history.replace("/schedule5")
            refresh()
        },
        confirmAppointment:(payload)=>{
            dispatch(confirmAppointment(payload))
            history.replace("/schedule6")
            refresh()
        }
        // selectAttendees: (payload) => {
        //     dispatch(selectAttendees(payload))
        //     history.replace("/schedule5")
        //     refresh()
        // }
    }
}


export const useSlots = (selectedDate) => {
    const dispatch = useDispatch()
    const availableSlots = useSelector(state => state.appointment.availableSlots)
    useEffect(() => {
        dispatch(getAvailableSlots({
            selectedDate
        }))
    }, [selectedDate,dispatch])
    return { availableSlots }
}

export const useAttendees = ({ isSingle }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(selectIsGroup(isSingle))
    }, [isSingle,dispatch])

    return {}
}

export const useSelectAttendees = () => {
    const userData = useQueryWithStore({
        type: "getList",
        resource: "_User",
        payload: {
            filter: {
            },
            pagination: { page: 1, perPage: 10 },
            sort: { field: "id", order: "ASC" }
        }
    })
    return userData
}

export const useEnhancedAppointmentData = () => {
    const appointment = useSelector(state => state.appointment)
    const attendeesData = useQueryWithStore({
        type: 'getMany',
        resource: '_User',
        payload: { ids: appointment.attendees }
    })
    const slotsData = useQueryWithStore({
        type: 'getMany',
        resource: 'MentorTimeSlot',
        payload: { ids: appointment.slots }
    })
    return {
        duration: appointment.slots.length * 30,
        date: slotsData.loaded ? slotsData.data[0].slotTime : null,
        attendeesData,
        slotsData,
        attendees: appointment.attendees,
        requestMessage: appointment.requestMessage,
        appointmentDuration: appointment.duration
    }
}